/* adventskiste.at - Inhalt der fertigen Kisten als Fenster (14.09.2026)

   Gegenstueck zu snippets/ak-kiste-inhalt.liquid. Oeffnet das Fenster
   ueber data-akf-open="<handle>" oder ueber die Adresse #inhalt-<handle>
   (so verlinkt die Startseite). Schliessen: Knopf, Klick daneben, Esc.

   Grusskarte: ohne Haken schickt das Formular ganz normal ab. Mit Haken
   gehen Kiste und Karte in EINEM Aufruf in den Warenkorb, damit nie die
   Kiste ohne die bestellte Karte darin liegt. Die Eigenschaft heisst
   wie im Builder "Grußkartentext". */
(function () {
  var open = null;
  var lastFocus = null;

  function focusables(m) {
    return m.querySelectorAll('button:not([disabled]), [href], input, textarea, select, [tabindex]:not([tabindex="-1"])');
  }

  function show(m) {
    if (!m || m === open) return;
    if (open) hide(true);
    lastFocus = document.activeElement;
    open = m;
    m.hidden = false;
    document.documentElement.classList.add('akf-modal-open');
    var close = m.querySelector('[data-akf-close]');
    if (close) close.focus();
  }

  function hide(silent) {
    if (!open) return;
    var m = open;
    m.hidden = true;
    open = null;
    document.documentElement.classList.remove('akf-modal-open');
    /* Die Adresse aufraeumen, sonst oeffnet das Fenster bei jedem
       Neuladen und jedem Zurueck wieder. */
    if (location.hash === '#' + m.id && window.history.replaceState) {
      window.history.replaceState(null, '', location.pathname + location.search);
    }
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-akf-open]');
    if (opener) {
      var m = document.getElementById('inhalt-' + opener.getAttribute('data-akf-open'));
      if (m) {
        e.preventDefault();
        show(m);
      }
      return;
    }
    if (!open) return;
    if (e.target === open || e.target.closest('[data-akf-close]')) hide();
  });

  document.addEventListener('keydown', function (e) {
    if (!open) return;
    if (e.key === 'Escape') {
      hide();
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables(open);
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ---------- Grusskarte ---------- */

  document.addEventListener('change', function (e) {
    var check = e.target.closest('[data-akf-card-check]');
    if (!check) return;
    var form = check.closest('.akf-modal').querySelector('.akf-modal__card-form');
    if (!form) return;
    form.hidden = !check.checked;
    if (check.checked) {
      var ta = form.querySelector('textarea');
      if (ta) ta.focus();
    }
  });

  document.addEventListener('input', function (e) {
    var ta = e.target.closest('[data-akf-card-text]');
    if (!ta) return;
    var m = ta.closest('.akf-modal');
    var count = m.querySelector('[data-akf-card-count]');
    if (count) count.textContent = ta.value.length;
    var err = m.querySelector('[data-akf-card-error]');
    if (err && ta.value.trim()) err.hidden = true;
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-akf-form]');
    if (!form) return;
    var m = form.closest('.akf-modal');
    var check = m && m.querySelector('[data-akf-card-check]');
    if (!check || !check.checked) return;

    e.preventDefault();
    var ta = m.querySelector('[data-akf-card-text]');
    var err = m.querySelector('[data-akf-card-error]');
    var text = ta ? ta.value.trim() : '';
    if (!text) {
      if (err) err.hidden = false;
      if (ta) ta.focus();
      return;
    }

    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    var items = [
      { id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: 1 },
      { id: parseInt(form.getAttribute('data-card-vid'), 10), quantity: 1, properties: { 'Grußkartentext': text } }
    ];
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add ' + r.status);
        window.location.href = '/cart';
      })
      .catch(function () {
        /* Notweg: wenigstens die Kiste, ueber das normale Formular. */
        if (btn) btn.disabled = false;
        form.submit();
      });
  });

  /* ---------- Aufruf ueber die Adresse ---------- */

  function fromHash() {
    var h = location.hash;
    if (!h || h.indexOf('#inhalt-') !== 0) return;
    var m = document.getElementById(h.slice(1));
    if (m && m.classList.contains('akf-modal')) show(m);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromHash);
  else fromHash();
  window.addEventListener('hashchange', fromHash);
})();
